import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, Download, Trash2, Eye } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface DocumentTableProps {
  searchQuery: string;
}

// Mock data
const documents = [
  {
    id: 1,
    name: "Personal Statement.pdf",
    type: "application/pdf",
    size: "2.4 MB",
    uploadedAt: new Date("2025-01-15"),
    category: "Required"
  },
  {
    id: 2,
    name: "Recommendation Letter 1.pdf",
    type: "application/pdf",
    size: "1.8 MB",
    uploadedAt: new Date("2025-01-16"),
    category: "Required"
  },
  {
    id: 3,
    name: "CV.pdf",
    type: "application/pdf",
    size: "890 KB",
    uploadedAt: new Date("2025-01-17"),
    category: "Required"
  }
];

const DocumentTable = ({ searchQuery }: DocumentTableProps) => {
  const filteredDocuments = documents.filter(doc =>
    doc.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Category</TableHead>
          <TableHead>Size</TableHead>
          <TableHead>Uploaded</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {filteredDocuments.map((doc) => (
          <TableRow key={doc.id}>
            <TableCell>
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>{doc.name}</span>
              </div>
            </TableCell>
            <TableCell>
              <Badge variant="secondary">{doc.category}</Badge>
            </TableCell>
            <TableCell>{doc.size}</TableCell>
            <TableCell>
              {formatDistanceToNow(doc.uploadedAt)} ago
            </TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-2">
                <Button variant="outline" size="sm">
                  <Eye className="h-4 w-4" />
                </Button>
                <Button variant="outline" size="sm">
                  <Download className="h-4 w-4" />
                </Button>
                <Button variant="outline" size="sm">
                  <Trash2 className="h-4 w-4 text-destructive" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DocumentTable;